
function trackEcommerce(event, ecommerceData) {
  if(!window.dataLayer) {
    return false
  }

  let data = { 'ecommerce': ecommerceData }

  if(event) {
    data.event = event
  }

  return window.dataLayer.push(data)
}

export {
  trackEcommerce,
}
